import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { warehouseApi as api } from '../../../../api/warehouse';

const DownloadLabelsModal = ({ isOpen, onClose, pendingDownloadIds, onComplete, rows }) => {
    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogTitle>Download Labels</DialogTitle>
            <DialogContent>
                <div style={{ padding: '20px 0' }}>
                    <p>You have selected one or more replenishment locations that have child locations.</p>
                    <p style={{ marginTop: '10px' }}>
                        Would you like to include child location labels in your download?
                    </p>
                </div>
            </DialogContent>
            <DialogContent>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            // Download only parent locations
                            api.bulkDownloadLocationLabels(pendingDownloadIds);
                            onComplete();
                        }}
                    >
                        Parent Locations Only
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            // Download parent + child locations
                            let parentAndChildIds = [];
                            pendingDownloadIds.forEach((parentID) => {
                                parentAndChildIds.push(parentID);
                                const parentRow = rows.find((row) => row.id === parentID);
                                if (parentRow && parentRow.childLocations) {
                                    parentRow.childLocations.forEach((child) => {
                                        if (child.active) {
                                            parentAndChildIds.push(child.id);
                                        }
                                    });
                                }
                            });
                            api.bulkDownloadLocationLabels(parentAndChildIds);
                            onComplete();
                        }}
                    >
                        Include Child Locations
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default DownloadLabelsModal;
